import vigilado_logos_gyf_wu from '../images/vigilado_logos_gyf_wu.png'

export const FooterComponent = () => {

    return (
        <footer className="yellow_bg px-2 px-lg-0">
            <div className="container text-center">
                <img src= {vigilado_logos_gyf_wu}
                alt="Vigilado Super Intendencia Financiera de Colombia. Giros y Finanzas. Western Union."  className='img-fluid'/>
            </div>
        </footer>
    )
}